import React from 'react'

import { Box } from '@domain-group/suit-theme'

interface FooterProps {
  children: React.ReactNode,
}

const Footer = (props: FooterProps) => {
  const { children } = props

  return (
    <Box
      borderTop="1px dashed"
      borderColor="lineColor"
      justifyContent="flex-end"
      padding="large"
    >
      {children}
    </Box>
  )
}

export default Footer
